module.exports = __webpack_public_path__ + "media/images/icons/credit_card_mastercard-b3bebd0dcc8af6e1645d91d725597886.svg";